export interface CentroCostoContable {
  idCentroCostoContable: number;
  codigo: string;
  descripcion: string;
  nivel: number;
  codigoPadre: string | null;
  idPadre: number | null;
  activo: boolean;
  hijos?: CentroCostoContable[];
}

export interface AreaContable {
  idAreaContable: number;
  codigo: string;
  descripcion: string;
  activo: boolean;
}

export const initialCentroCosto: Partial<CentroCostoContable> = {
  idCentroCostoContable: 0,
  codigo: '',
  descripcion: '',
  nivel: 1,
  codigoPadre: null,
  idPadre: null,
  activo: true,
};
